/**
 * QUEL ORGANIGRAMME MONTRER — module PUR (04/10/2026).
 *
 * Le personnel lit la DERNIÈRE VERSION APPROUVÉE ; le RQ et la RH lisent le
 * brouillon, qu'ils préparent et signent. Voir l'en-tête de
 * `backend/src/org-instantane.ts`.
 *
 * Trois sources, et l'écran doit savoir laquelle il affiche pour le DIRE :
 *  - `brouillon`  : révision ouverte, lue par qui la prépare ;
 *  - `approuvee`  : la copie figée à la dernière approbation ;
 *  - `vivant`     : pas de révision ouverte — le vivant EST l'approuvé ;
 *  - `sansCopie`  : révision ouverte mais aucune copie encore (aucune
 *                   approbation depuis le 04/10/2026) : le personnel voit le
 *                   brouillon, comme avant, et l'écran doit le dire.
 */
type Personne = { id: string };

export type SourceOrg = 'brouillon' | 'approuvee' | 'vivant' | 'sansCopie';

export function organigrammeAffiche<P extends Personne>(opts: {
  vivant: P[];
  instantane?: { personnes?: P[] } | null;
  etat?: 'brouillon' | 'averifier' | 'approuvee';
  /** RQ ou RH : ceux qui préparent et signent. */
  voitBrouillon: boolean;
  /** En modification, on travaille TOUJOURS sur le vivant. */
  enEdition?: boolean;
}): { personnes: P[]; source: SourceOrg } {
  const enRevision = !!opts.etat && opts.etat !== 'approuvee';
  if (!enRevision) return { personnes: opts.vivant, source: 'vivant' };
  if (opts.voitBrouillon || opts.enEdition) return { personnes: opts.vivant, source: 'brouillon' };
  const copie = opts.instantane?.personnes;
  if (Array.isArray(copie) && copie.length) return { personnes: copie, source: 'approuvee' };
  return { personnes: opts.vivant, source: 'sansCopie' };
}
